import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const res = await login(email, password);
        setBusy(false);
        if (res.ok) navigate("/dashboard");
        else setErr(res.error);
    };

    return (
        <div className="max-w-md mx-auto px-6 py-16">
            <div className="glass rounded-2xl p-8">
                <h1 className="font-heading text-3xl font-semibold tracking-tight mb-2">Welcome back</h1>
                <p className="text-sm text-[var(--lt-muted)] mb-8">
                    Log in to save your progress and climb the leaderboard.
                </p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="eyebrow block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-[var(--lt-bg-2)] border border-[var(--lt-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lt-terracotta)]"
                            data-testid="login-email-input"
                            placeholder="you@example.com"
                        />
                    </div>
                    <div>
                        <label className="eyebrow block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-[var(--lt-bg-2)] border border-[var(--lt-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lt-terracotta)]"
                            data-testid="login-password-input"
                            placeholder="••••••••"
                        />
                    </div>
                    {err && (
                        <p className="text-sm text-red-400" data-testid="login-error">
                            {err}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        className="btn-terra w-full disabled:opacity-60"
                        data-testid="login-submit-btn"
                    >
                        {busy ? "Signing in…" : "Sign In"}
                    </button>
                </form>
                <p className="mt-6 text-sm text-[var(--lt-muted)] text-center">
                    No account?{" "}
                    <Link to="/register" className="text-[var(--lt-terracotta)] hover:underline">
                        Create one
                    </Link>
                </p>
            </div>
        </div>
    );
}
